import { StyleSheet, css } from 'aphrodite'

interface Company {
  name?: string
  address?: string
  street_address?: string
  city?: string
  state?: string
  zip_code?: string
}

interface CompanyInfoDisplayProps {
  company: Company | undefined | null
}

// Helper to format company address from structured fields
const formatCompanyAddress = (company: Company | undefined | null): string => {
  if (!company) return 'Address not available'

  // If we have structured address fields, use them
  if (
    company.street_address ||
    company.city ||
    company.state ||
    company.zip_code
  ) {
    const parts = []
    if (company.street_address) parts.push(company.street_address)
    if (company.city) parts.push(company.city)
    if (company.state) parts.push(company.state)
    if (company.zip_code) parts.push(company.zip_code)
    return parts.join(', ')
  }

  // Fall back to full address
  return company.address || 'Address not available'
}

const CompanyInfoDisplay: React.FC<CompanyInfoDisplayProps> = ({ company }) => {
  if (!company) return null

  return (
    <div className={css(styles.container)}>
      {company.name && (
        <div className={css(styles.companyName)}>{company.name}</div>
      )}
      <div className={css(styles.companyAddress)}>
        {formatCompanyAddress(company)}
      </div>
    </div>
  )
}

const styles = StyleSheet.create({
  container: {
    marginTop: '8px',
    padding: '8px 12px',
    backgroundColor: '#F9FAFB',
    borderRadius: '6px',
    border: '1px solid #E5E7EB',
  },
  companyName: {
    fontSize: '13px',
    fontWeight: 600,
    color: '#374151',
    marginBottom: '2px',
  },
  companyAddress: {
    fontSize: '12px',
    color: '#6B7280',
  },
})

export default CompanyInfoDisplay
